const ApiException = ({ error }) => {
    const description = error.response?.data["description"];
    const code = error.response?.data["error_code"];
    const reference_id = error.response?.data["reference_id"];
    return (
        <>
            <h1>Oops! Something went wrong</h1>
            <p>
                Sorry, an unexpected error has occurred. Please contact support
                along with the reference id.
            </p>
            <p>Error Code: {code}</p>
            <p>Description: {description}</p>
            <p>Reference Id: {reference_id}</p>
        </>
    );
};

export default ApiException;
